import { Card } from "components/atoms/Card";
import { SliderInput } from "components/atoms/Slider";
import { FormProvider } from "react-hook-form";
import { useMinimunScore } from "./model/useMinimunScore";
import Button from "components/atoms/Button/Button";

export const MinimunScoreModule = () => {
  const { form, isLoading, handleSubmit, isDisabled } = useMinimunScore();

  return (
    <form onSubmit={form.handleSubmit(handleSubmit)}>
      <FormProvider {...form}>
        <Card
          icon="fire"
          className="pb-14 gap-14"
          buttonComponent={
            <Button
              buttonContainerClassName="gap-2"
              isProcessing={isLoading}
              disabled={isDisabled}
              iconName="save"
              size="xs"
              action="submit"
            >
              Save
            </Button>
          }
          title="Auto-Reveal Hot Leads"
          subtitle="Set your minimum ICP and Behavior scores for a lead to be revealed. When a lead is revealed, you get real-time, verified contact information and that lead is sent to your integrations."
        >
          <div className="grid grid-cols-12 pl-10">
            <div className="col-span-4">
              <SliderInput
                icon="target-outline"
                name="icp"
                label="Minimum ICP Score"
              />
            </div>
            <div className="col-span-4 col-start-6">
              <SliderInput
                icon="behavior"
                name="behavior"
                label="Minimum Behavior Score"
              />
            </div>
          </div>
        </Card>
      </FormProvider>
    </form>
  );
};
